var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlobalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 9C2 4.86 5.3525 1.5 9.4925 1.5C13.64 1.5 17 4.86 17 9C17 13.14 13.64 16.5 9.4925 16.5C5.3525 16.5 2 13.14 2 9ZM12.4775 6H14.69C13.97 4.7625 12.8225 3.8025 11.4425 3.33C11.8925 4.1625 12.2375 5.0625 12.4775 6ZM9.5 3.03C10.1225 3.93 10.61 4.9275 10.9325 6H8.0675C8.39 4.9275 8.8775 3.93 9.5 3.03ZM3.5 9C3.5 9.5175 3.575 10.02 3.695 10.5H6.23C6.17 10.005 6.125 9.51 6.125 9C6.125 8.49 6.17 7.995 6.23 7.5H3.695C3.575 7.98 3.5 8.4825 3.5 9ZM4.31 12H6.5225C6.7625 12.9375 7.1075 13.8375 7.5575 14.67C6.1775 14.1975 5.03 13.245 4.31 12ZM4.31 6H6.5225C6.7625 5.0625 7.1075 4.1625 7.5575 3.33C6.1775 3.8025 5.03 4.755 4.31 6ZM9.5 14.97C8.8775 14.07 8.39 13.0725 8.0675 12H10.9325C10.61 13.0725 10.1225 14.07 9.5 14.97ZM7.625 9C7.625 9.51 7.6775 10.005 7.745 10.5H11.255C11.3225 10.005 11.375 9.51 11.375 9C11.375 8.49 11.3225 7.9875 11.255 7.5H7.745C7.6775 7.9875 7.625 8.49 7.625 9ZM11.4425 14.67C11.8925 13.8375 12.2375 12.9375 12.4775 12H14.69C13.97 13.2375 12.8225 14.1975 11.4425 14.67ZM12.875 9C12.875 9.51 12.83 10.005 12.77 10.5H15.305C15.425 10.02 15.5 9.5175 15.5 9C15.5 8.4825 15.425 7.98 15.305 7.5H12.77C12.83 7.995 12.875 8.49 12.875 9Z",
    fill: "#C0D0FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobalIcon);
export default __webpack_public_path__ + "static/media/Global_Icon.6034c77dcf671d06adfeb45e14d9592d.svg";
export { ForwardRef as ReactComponent };